import React from 'react';
import type { FC } from 'react';

import { WhatsNewInConfluenceErrorBoundary } from './WhatsNewInConfluence';

type WhatsNewInConfluenceNav3rProps = {
	rightSidebarCompensation: number;
};

export const WhatsNewInConfluenceNav3: FC<WhatsNewInConfluenceNav3rProps> = () => {
	return <WhatsNewInConfluenceErrorBoundary />;
};
